import { createNote, updateNote, deleteNote } from "../api/orders";
import type { KitRecord } from "../types/orders";

interface UseNotesOptions {
  updateItem: (id: string, updater: (item: KitRecord) => KitRecord) => void;
  showToast: (message: string, variant?: "success" | "error") => void;
}

export function useNotes({ updateItem, showToast }: UseNotesOptions) {
  async function handleSaveNote(recordId: string, text: string, hasExisting: boolean) {
    try {
      if (hasExisting) {
        await updateNote(recordId, text);
      } else {
        await createNote(recordId, text);
      }
      updateItem(recordId, (it) => ({ ...it, note: text }));
      showToast("Note saved");
    } catch (err) {
      showToast(err instanceof Error ? err.message : "Failed to save note", "error");
    }
  }

  async function handleDeleteNote(recordId: string) {
    try {
      await deleteNote(recordId);
      updateItem(recordId, (it) => ({ ...it, note: null }));
      showToast("Note deleted");
    } catch (err) {
      showToast(err instanceof Error ? err.message : "Failed to delete note", "error");
    }
  }

  return { handleSaveNote, handleDeleteNote };
}
